import { stringToDate } from "@dhx/ts-common/date";
import { IFormats } from "../types";

export function getExcelDateFromJs(jsDate: Date): number {
	const returnDateTime = 25569 + (jsDate.getTime() - jsDate.getTimezoneOffset() * 60000) / (86400 * 1000);
	return returnDateTime;
}

export function excelDateToJSDate(number: number) {
	const date = new Date(Math.round((number - 25569) * 86400 * 1000));
	return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
}

export function addDay(d: Date, count = 1): Date {
	return new Date(d.getFullYear(), d.getMonth(), d.getDate() + count);
}
export function addTime(d: Date, count = 3600 * 1000): Date {
	return new Date(d.getTime() + count);
}
export function dateDiff(d1: Date, d2: Date): number {
	const t2 = d2.getTime();
	const t1 = d1.getTime();
	return parseInt(`${(t2 - t1) / (24 * 3600 * 1000)}`);
}

export function timeDiff(d1: Date, d2: Date): number {
	const date1 = new Date();
	const date2 = new Date();
	date1.setHours(d1.getHours(), d1.getMinutes(), d1.getSeconds());
	date2.setHours(d2.getHours(), d2.getMinutes(), d2.getSeconds());
	const t2 = date2.getTime();
	const t1 = date1.getTime();
	return parseInt(`${t2 - t1}`);
}

function validate(value: number, max: number): number {
	if (isNaN(value)) {
		return 0;
	}
	return Math.min(max, Math.max(0, value));
}

export function timeStringToJS(value: string): Date | string {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	let m = 0;
	let h = 0;
	let s = 0;
	let isPM: boolean;
	if (typeof value === "string") {
		const matches = value.match(/\d+/g);
		if (!matches) return value;
		if (value.toLowerCase().includes("pm")) {
			isPM = true;
		}
		h = validate(+matches[0], 23) + (isPM ? 12 : 0);
		m = validate(+matches[1], 59);
		s = validate(+matches[2], 59);
	}

	const date = new Date(1991, 0, 1, h, m, s);

	return date;
}
export function isTimeCheck(value: any): boolean {
	return /([0-2][0-9]:[0-5][0-9]:[0-5][0-9])/i.test(value);
}

export function getExcelDateFromString(value: string | number, format: IFormats ): string | number {
	if (typeof value !== "string") return value
	const id = format.id;
	let val: string | number = value;
	switch (id) {
		case "date":
			const date = stringToDate(value, format.dateFormat, true);
			val = date
				? getExcelDateFromJs(stringToDate(value, format.dateFormat))
				: value;
			break;
		case "time":
			const time = timeStringToJS(value);
			val = typeof time === "string" ? time : getExcelDateFromJs(time);
	}
	return val
}
